import { render, staticRenderFns } from "./PersonFiles.vue?vue&type=template&id=6780e0d8"
import script from "./PersonFiles.vue?vue&type=script&lang=ts"
export * from "./PersonFiles.vue?vue&type=script&lang=ts"
import style0 from "./PersonFiles.vue?vue&type=style&index=0&id=6780e0d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports